import { render, staticRenderFns } from "./form-detail-promotor.vue?vue&type=template&id=63919734&scoped=true"
import script from "./form-detail-promotor.vue?vue&type=script&lang=js"
export * from "./form-detail-promotor.vue?vue&type=script&lang=js"
import style0 from "./form-detail-promotor.vue?vue&type=style&index=0&id=63919734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63919734",
  null
  
)

export default component.exports